import React from 'react';
import { StarIcon } from 'lucide-react';
import { CTAButton } from './ui/CTAButton';
import { TrustBadges } from './ui/TrustBadges';
export function TestimonialsSection() {
  const testimonials = [{
    name: 'María García',
    location: 'Guadalajara, JAL',
    initials: 'MG',
    image: 'https://cdn.magicpatterns.com/uploads/oeQBGAb4y6yp4g1u1SXHW2/ChatGPT_Image_Mar_14,_2026,_07_51_28_AM.png',
    text: 'Llevaba meses con dolor de rodilla y esta rodillera me cambió la vida. El calor es muy reconfortante y me permite dormir sin molestias.'
  }, {
    name: 'Carlos Hernández',
    location: 'CDMX',
    initials: 'CH',
    image: 'https://cdn.magicpatterns.com/uploads/ibcTtudjCkvws2WjvZAGwg/ChatGPT_Image_Mar_14,_2026,_07_52_58_AM.png',
    text: 'La uso todos los días después del trabajo. Mi rodilla ya no se inflama como antes. 100% recomendada, y el pago contra entrega me dio mucha confianza.'
  }, {
    name: 'Ana López',
    location: 'Monterrey, NL',
    initials: 'AL',
    image: 'https://cdn.magicpatterns.com/uploads/7sU2HPe7PcGpUCeToxmQdB/ChatGPT_Image_Mar_14,_2026,_07_52_12_AM.png',
    text: 'Pedí 2, una para mí y otra para mi mamá. Las dos estamos encantadas. El envío fue rápido y la calidad del material es excelente.'
  }];
  return <section className="w-full bg-blue-50 py-16 px-4" data-id="element-207">
      <div className="max-w-5xl mx-auto" data-id="element-208">
        <div className="text-center mb-12" data-id="element-209">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4" data-id="element-210">
            Lo Que Dicen Nuestros Clientes
          </h2>
          <div className="flex items-center justify-center gap-1 mb-2" data-id="element-211">
            {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-6 h-6 fill-yellow-400 text-yellow-400" data-id="element-212" />)}
          </div>
          <p className="text-lg text-slate-600" data-id="element-213">
            Calificación promedio de 4.9/5 basada en clientes reales de México.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-214">
          {testimonials.map((test, idx) => <div key={idx} className="bg-white p-8 rounded-2xl shadow-sm border border-slate-100" data-id="element-215">
              <div className="flex items-center gap-1 mb-4" data-id="element-216">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-217" />)}
              </div>
              <p className="text-slate-700 italic mb-6" data-id="element-218">"{test.text}"</p>
              <div className="flex items-center gap-4" data-id="element-219">
                <div className="w-12 h-12 bg-blue-100 text-blue-700 rounded-full flex items-center justify-center font-bold text-lg shrink-0" data-id="element-220">
                  {test.initials}
                </div>
                <div data-id="element-221">
                  <p className="font-bold text-slate-900" data-id="element-222">{test.name}</p>
                  <p className="text-sm text-slate-500 flex items-center gap-1" data-id="element-223">
                    <span className="w-2 h-2 bg-green-500 rounded-full" data-id="element-224"></span>
                    Comprador Verificado • {test.location}
                  </p>
                </div>
              </div>
            </div>)}
        </div>

        <div className="mt-12 max-w-md mx-auto" data-id="element-225">
          <CTAButton text="Únete a Miles de Clientes Satisfechos" data-id="element-226" />
          <TrustBadges className="mt-4" data-id="element-227" />
        </div>
      </div>
    </section>;
}